// native
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// model
import { IDisplayItem, ICitationOptions } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CitationsQueueService {

  citationQueueItems: IDisplayItem[] = [];
  citationQueueOptions: ICitationOptions;

  overridePanelVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get citationQueueItemIds(): string[] {
    const ids: string[] = [];

    this.citationQueueItems.forEach((item: IDisplayItem)=>{
      ids.push(item.id);
    });

    return ids;
  }
}